module.exports = __webpack_public_path__ + "img/rotate-exclamation.a960a007.svg";